import React from "react"

import styles from "./OfferTable.css"
import { addDays, differenceInCalendarISOWeeks, eachDayOfInterval, endOfISOWeek, format, formatISO, getDay, getISOWeek, isAfter, isBefore, isSameDay, isWithinInterval, max, min, startOfISOWeek } from "date-fns"
import { de } from "date-fns/locale"

export function OfferTable({ children, capacityData }) {
    if (React.Children.count(children) == 0) return null;

    const minDate = min(React.Children.map(children, child => child.props.begin))
    const maxDate = max(React.Children.map(children, child => child.props.end))
    const beginDate = startOfISOWeek(minDate)
    const endDate = endOfISOWeek(maxDate)
    const weeks = differenceInCalendarISOWeeks(endDate, beginDate) + 1
    const startWeek = getISOWeek(beginDate)

    return <div>{[...Array(weeks).keys()].map(offset => {
        const beginOfWeek = addDays(beginDate, offset * 7)
        const endOfWeek = addDays(beginOfWeek, 6)

        const weekChildren = React.Children.toArray(children).
            filter(child => {
                const minWeek = getISOWeek(child.props.begin)
                const maxWeek = getISOWeek(child.props.end)

                return (minWeek <= getISOWeek(beginOfWeek)) && (maxWeek >= getISOWeek(beginOfWeek))

                //isWithinInterval(beginOfWeek, { start: child.props.begin, end: child.props.end })
                //isWithinInterval(endOfWeek, { start: child.props.begin, end: child.props.end }))
            })

            .map(child => {
                return {
                    child,
                    begin: max([child.props.begin, beginOfWeek]),
                    end: min([child.props.end, endOfWeek])
                }
            })

        if (weekChildren.length == 0) return null;

        return <Week week={startWeek + offset} begin={beginOfWeek} end={endOfWeek}>
            {weekChildren.map(({ child, begin, end }) => React.cloneElement(child, { begin, end }))}
        </Week>
    })}

        <p className={styles.Legend}>Legende:
            <span className={styles.ItemLegend}>freie Plätze</span>
            <span className={[styles.ItemLegend, styles.ItemWaitingList].join(" ")}>Warteliste</span>
        </p>

    </div>
}

OfferTable.Item = function Item({ title, daily, begin, end, onToggleDate, disabledDates = [], selectedDates = [], isWaitingList }) {
    const startOfWeek = startOfISOWeek(begin)
    const endOfWeek = endOfISOWeek(end)
    const week = getISOWeek(startOfWeek)

    const content = daily ? eachDayOfInterval({ start: startOfWeek, end: endOfWeek }).map(date => {
        if (isWithinInterval(date, { start: begin, end: end })) {
            return <div
                role="button"
                disabled={disabledDates.filter(d => d.getTime() === date.getTime()).length > 0}
                data-selected={selectedDates.filter(d => d.getTime() === date.getTime()).length > 0}
                className={[
                    styles.ItemDay,
                    isWaitingList(date) ? styles.ItemWaitingList : undefined
                ].join(" ")}
                onClick={() => onToggleDate(date)}>
                {format(date, "E", { locale: de })}
            </div>
        }

        return <div className={styles.ItemDay} disabled>{format(date, "E", { locale: de })}</div>
    }) : <div
        role="button"
        className={[
            styles.ItemWeek,
            eachDayOfInterval({ start: begin, end: end }).some(d => isWaitingList(d)) ? styles.ItemWaitingList : undefined
        ].join(" ")}
        data-selected={selectedDates.filter(d => d.getTime() === begin.getTime()).length > 0}
        onClick={() => onToggleDate(begin)}
    >
        {format(begin, "E", { locale: de })} - {format(end, "E", { locale: de })}
    </div>

    return <div className={styles.Item}>
        <span className={styles.ItemTitle}>{title}</span>
        {content}
    </div>
}

function Week({ week, begin, end, children }) {
    return <div className={styles.Week}>
        <span className={styles.WeekTitle}>
            KW {week} / {format(begin, "EEEEEE. d.MM.", { locale: de })} - {format(end, "EEEEEE. d.MM.", { locale: de })}
        </span>
        {children}
    </div>
}

